module.exports = __webpack_public_path__ + "img/domain-hov.cce19f91.svg";